import { Navigate } from 'react-router-dom'
import { LoginForm } from '@/components/auth/LoginForm'
import { useAuthStore } from '@/stores/authStore'
import { useInstanceStore, isInstanceComplete } from '@/stores/instanceStore'

export function LoginPage() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)
  const instance = useInstanceStore((state) => state.instance)
  const instanceComplete = isInstanceComplete(instance)
  const displayName = instanceComplete ? 'E-QUIPE ERP' : instance.name

  if (isAuthenticated) {
    return <Navigate to="/" replace />
  }

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-950 flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        {/* Logo e titolo */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-12 h-12 bg-primary-500 rounded-2xl mb-4 shadow-card">
            <span className="text-white text-xl font-bold tracking-tight">
              {displayName.charAt(0).toUpperCase()}
            </span>
          </div>
          <h1 className="text-2xl font-bold text-slate-900 tracking-tight">{displayName}</h1>
          <p className="text-sm text-slate-500 mt-1.5">
            Accedi al tuo account
          </p>
        </div>

        {/* Card form */}
        <div className="bg-white dark:bg-slate-800 rounded-2xl border border-slate-200 dark:border-slate-700 shadow-card p-6">
          <LoginForm />
        </div>

        {/* Footer */}
        <p className="text-center text-xs text-slate-400 mt-6">
          {displayName} &copy; {new Date().getFullYear()}
        </p>
      </div>
    </div>
  )
}
